/** Small outline icons for the mobile tab bar (24px grid, stroke = currentColor) */
const paths: Record<string, string> = {
  gate: 'M4 20V9l8-5 8 5v11M9 20v-6h6v6M2 20h20',
  students: 'M12 4l9 4-9 4-9-4 9-4zM6 10v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5',
  users: 'M9 11a4 4 0 100-8 4 4 0 000 8zM2 21v-1a6 6 0 0112 0v1M16 3.5a4 4 0 010 7.5M22 21v-1a6 6 0 00-4-5.6',
  messages: 'M4 5h16v11H8l-4 4V5z',
  reports: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  audit: 'M8 6h12M8 12h12M8 18h12M3.5 6h.01M3.5 12h.01M3.5 18h.01',
  settings: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 13.5l1.6 1.2-2 3.5-1.9-.7a7 7 0 01-2 1.2l-.3 2h-4l-.3-2a7 7 0 01-2-1.2l-1.9.7-2-3.5 1.6-1.2a7 7 0 010-3l-1.6-1.2 2-3.5 1.9.7a7 7 0 012-1.2l.3-2h4l.3 2a7 7 0 012 1.2l1.9-.7 2 3.5-1.6 1.2a7 7 0 010 3z',
  account: 'M12 12a4 4 0 100-8 4 4 0 000 8zM4 21a8 8 0 0116 0',
  today: 'M3 10l9-7 9 7v10a1 1 0 01-1 1h-5v-6H9v6H4a1 1 0 01-1-1V10z',
  people: 'M8 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM1.5 20a6.5 6.5 0 0113 0M17 11a3 3 0 100-6M18 14.5a5.5 5.5 0 014.5 5.5',
  changes: 'M4 6h16v14H4zM4 10h16M9 3v4M15 3v4M9 15l2 2 4-4',
  history: 'M12 7v5l3 2M3.5 12a8.5 8.5 0 108.5-8.5A8.5 8.5 0 004.6 8M3 4v4h4',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  scan: 'M4 8V5a1 1 0 011-1h3M16 4h3a1 1 0 011 1v3M20 16v3a1 1 0 01-1 1h-3M8 20H5a1 1 0 01-1-1v-3M7 12h10',
  signout: 'M15 4h4a1 1 0 011 1v14a1 1 0 01-1 1h-4M10 17l5-5-5-5M15 12H3',
  phone: 'M8 2.5h8a1.5 1.5 0 011.5 1.5v16a1.5 1.5 0 01-1.5 1.5H8A1.5 1.5 0 016.5 20V4A1.5 1.5 0 018 2.5zM11 18.5h2',
  mail: 'M3.5 6h17v12h-17zM3.5 6.5l8.5 6.5 8.5-6.5',
  arrow: 'M5 12h14M13 6l6 6-6 6',
  qr: 'M4 8V5a1 1 0 011-1h3M16 4h3a1 1 0 011 1v3M20 16v3a1 1 0 01-1 1h-3M8 20H5a1 1 0 01-1-1v-3M8 12h.01M12 12h.01M16 12h.01',
  info: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 11v5M12 8h.01',
  globe: 'M12 21a9 9 0 100-18 9 9 0 000 18zM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9S9.5 5.5 12 3z',
  shield: 'M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3zM8.5 12l2.5 2.5 4.5-5',
  bell: 'M6 16V11a6 6 0 0112 0v5l1.5 2h-15L6 16zM10 20.5a2 2 0 004 0',
  group: 'M12 11a3 3 0 100-6 3 3 0 000 6zM5 12a2.2 2.2 0 100-4.4M19 12a2.2 2.2 0 100-4.4M6.5 20c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5M1.5 19c0-2.2 1.6-4 3.5-4.3M22.5 19c0-2.2-1.6-4-3.5-4.3',
  calendar: 'M4 6.5h16v13.5H4zM4 10.5h16M8.5 3.5v4M15.5 3.5v4',
  pin: 'M12 21s-6.5-6-6.5-11a6.5 6.5 0 0113 0c0 5-6.5 11-6.5 11zM12 12.3a2.3 2.3 0 100-4.6 2.3 2.3 0 000 4.6z',
  plus: 'M12 5v14M5 12h14',
  camera: 'M4 8h3.5l1.5-2.5h6L16.5 8H20v11H4zM12 16.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z',
  pencil: 'M4 20l1-4.5L15.5 5a2.1 2.1 0 013 3L8 18.5zM14 6.5l3.5 3.5',
  trash: 'M4 7h16M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13M10 11v5.5M14 11v5.5',
  clock: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 7.5V12l3 2',
  walk: 'M13.5 5.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM9 21l2.5-6.5 2.5 2.5V21M7.5 12.5l2-4.5 3.5-.5 2 3.5 2.5 1M11.5 14.5l-1-5',
  user: 'M12 11.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM5 20a7 7 0 0114 0',
  note: 'M6 3.5h9l4 4v13H6zM15 3.5v4h4M9 12h7M9 16h5',
  send: 'M21 3L10.5 13.5M21 3l-6.5 18-4-7.5L3 9.5z',
  chevron: 'M9 6l6 6-6 6',
  chevronDown: 'M6 9l6 6 6-6',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  home: 'M3 11l9-7.5 9 7.5M5.5 9.5V20h13V9.5',
  x: 'M6 6l12 12M18 6L6 18',
  car: 'M5 11l1.6-4.3A2 2 0 018.5 5.4h7a2 2 0 011.9 1.3L19 11M4 11h16a1 1 0 011 1v4.5H3V12a1 1 0 011-1zM5 16.5V19h3v-2.5M16 16.5V19h3v-2.5M7 14h.01M17 14h.01',
  search: 'M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-4-4',
  alert: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 7.5v5.5M12 16.5h.01',
  warning: 'M12 3.5l9.5 16.5h-19zM12 10v4.5M12 17.5h.01',
  hourglass: 'M6.5 3h11M6.5 21h11M8 3c0 4.5 8 5 8 9s-8 4.5-8 9M16 3c0 4.5-8 5-8 9s8 4.5 8 9',
  refresh: 'M20 11.5A8 8 0 104.6 15M20 4.5v7h-7',
  palette: 'M12 3a9 9 0 100 18c1.1 0 1.6-.8 1.6-1.6 0-1.2-1-1.5-1-2.6s.8-1.8 2-1.8H17a4 4 0 004-4c0-4.4-4-8-9-8zM7.5 12h.01M9.5 7.8h.01M14.5 7.8h.01',
  building: 'M4 21V8.5l8-5 8 5V21M2 21h20M9.5 21v-5h5v5M8.5 11h.01M12 11h.01M15.5 11h.01M8.5 14h.01M15.5 14h.01',
  userPlus: 'M10 11.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM3 20a7 7 0 0113.5-2.6M19 14v6M16 17h6',
  card: 'M3 6.5h18v11H3zM3 10h18M7 14.5h4',
};

export function Icon({ name, size = 24, className }: { name: keyof typeof paths | string; size?: number; className?: string }) {
  return (
    <svg className={className ? `icon ${className}` : 'icon'} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth={name === 'more' ? 3.5 : 1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d={paths[name] ?? paths.more} />
    </svg>
  );
}
